module.exports = __webpack_public_path__ + "static/media/a2pas.136cbbe6.png";